<template>
  <div id="app">
    <top/>
    <index/>
    <div class="background-image"></div>
  </div>
</template>

<script>
import top from './components/01.top.vue';
import index from './components/02.index.vue';

export default {
  name: 'app',
  components: {
    top,
    index
  }
};
</script>

<style>
.background-image {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('images/bh3fhbg01.jpg');
  background-size: cover;
  background-position: center;
  opacity: 0.5;
  z-index: -1;
}
</style>
